/** @jsx isolateComponent */
// @ts-ignore
import * as React from 'react';

import { Colors, Spinner } from '@zapier/design-system';
import { Document } from '@zapier/common-components';
import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/responsive-utils';
import {
  isolateComponent,
  labelStyles,
  responsiveStyles,
} from '@zapier/common-utils';

import Form from 'app/developer-v3/components/PartnerSupportForm/components/Form/Form';
import { TrackingProvider } from 'app/developer-v3/components/PartnerSupportForm/contexts/TrackingContext';
import {
  FormProvider,
  SizeType,
} from 'app/developer-v3/components/PartnerSupportForm/contexts/FormContext';

type AppProps = {
  query: {
    [key: string]: string;
  };
};

const Styles = labelStyles(__filename, {
  root: {
    // both needed to make sure we don't show grey once we've loaded
    backgroundColor: Colors.PrimeWhite,
    flex: 1,
  },
  container: (size: SizeType) =>
    responsiveStyles(size, {
      small: {
        display: 'flex',
        justifyContent: 'center',
        margin: '70px auto',
        padding: '0 10px',
      },
      large: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0 20px',
        maxWidth: `${20 + 712 + 20}px`,
      },
    }),
});

const ContactPage = ({ query }: AppProps) => {
  const size: SizeType = useMediaProps({
    all: {
      size: 'small',
    },
    [Screen.queries.tablet]: { size: 'medium' },
    [Screen.queries.desktop]: { size: 'large' },
  }).size;

  return (
    <Document title="Get Help">
      <section css={Styles.root}>
        <div css={Styles.container(size)}>
          <FormProvider query={query} size={size}>
            {({ isLoading }) =>
              isLoading ? (
                <Spinner size="large" />
              ) : (
                <div>
                  <TrackingProvider>
                    <Form />
                  </TrackingProvider>
                </div>
              )
            }
          </FormProvider>
        </div>
      </section>
    </Document>
  );
};

export default ContactPage;
